<template>
  <div class="container">
    <el-col :span="24" class="header">
      <el-col :span="4" class="logo">
        <span><i class="txt">宠品仓-管理员后台系统</i></span>
      </el-col>
      <el-col :offset="18" :span="2" class="userinfo">
        <el-dropdown @command="manyCommand">
          <span class="el-dropdown-link">{{username}}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="loginout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-col>
    <el-col :span="24" class="main">
      <section :class="menuClass">
        <el-menu :default-active="$route.path" class="el-menu-vertical-demo" :collapse="isCollapse" theme="dark" router unique-opened>
          <li class="el-menu-item fold" @click="toggleSidebar"><i :class="menuIcon"></i></li>
          <template v-for="(item,index) in $router.options.routes" v-if="!item.hidden">
            <el-submenu :index="index+''" v-if="!item.leaf">
              <template slot="title"><i :class="item.iconCls"></i><span slot="title">{{item.name}}</span></template>
              <el-menu-item v-for="(child,index) in item.children" :index="child.path" v-if="!child.hidden">{{child.name}}</el-menu-item>
            </el-submenu>
            <el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path">
              <i :class="item.iconCls"></i>
              <span slot="title">{{item.children[0].name}}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </section>
      <div :class="containerClass">
        <div class="content-wrapper">
          <router-view></router-view>
        </div>
      </div>
    </el-col>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        username: this.$cookie.get('user') ? this.$cookie.get('user').split('|')[1] : '',
        isCollapse: false,
        menuClass: 'content-menu',
        menuIcon: 'el-icon-caret-left',
        containerClass: 'content-container'
      };
    },
    methods: {
      manyCommand(command) {
        switch(command) {
          case "loginout":
            this.$cookie.delete('user');
            this.$router.push({ path: '/login' });
            break;
        }
      },
      toggleSidebar() {
        if(this.isCollapse) {
          this.isCollapse = false;
          this.menuIcon = 'el-icon-caret-left';
          this.menuClass = 'content-menu';
          this.containerClass = 'content-container';
        } else {
          this.isCollapse = true;
          this.menuIcon = 'el-icon-caret-right';
          this.menuClass = 'content-menu content-menu-width';
          this.containerClass = 'content-container container-left';
        }
      }
    }
  }
</script>

<style type="text/css">
  .container {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
  }
  .header {
    height: 60px;
    line-height: 60px;
    background: #373d41;
    color: #c0ccda;
  }
  .userinfo {
    text-align: right;
    padding-right: 35px;
  }
  .userinfo .el-dropdown {
    font-size: 16px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #c0ccda;
  }
  .logo {
    font-size: 22px;
  }
  .logo img {
    width: 40px;
    float: left;
    margin: 15px 10px 10px 18px;
  }
  .txt {
    color: #20a0ff
  }
  .main {
    background: #324057;
    position: absolute;
    top: 60px;
    bottom: 0;
    overflow: hidden;
    padding-bottom: 40px;
    box-sizing: border-box;
  }
  aside {
    width: 230px;
  }
  .content-menu {
    position: fixed;
    top: 60px;
    bottom: 0;
    background-color: #333744;
    width: 12%;
    z-index: 10;
  }
  .content-menu-width {
    width: 4%;
  }
  body .el-menu--collapse {
    width: 100%;
  }
  .content-container {
    background: #eaedf1;
    width: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
    left: 12%;
  }
  .container-left {
    left: 4%;
  }
  .content-wrapper {
    position: absolute;
    width: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-y: auto;
    -webkit-transition: all 0.2s ease;
    padding: 20px;
  }
  body .fold {
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: #4A5064;
  }
  .breadcrumb-container {
    margin-bottom: 15px;
  }
  .title {
    width: 200px;
    float: left;
    color: #475669;
  }
  .breadcrumb-inner {
    float: right;
  }
  a {
    text-decoration: none;
    color: #2fa4e7;
    background-color: transparent;
  }
  a:hover {
    text-decoration: underline;
    color: #58baf3;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 220px;
    line-height: 220px;
    text-align: center;
  }
  .avatar {
    width: 200px;
    height: 220px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// home.vue?0cd39808